/**
 * Utilitários de snowflake e de tempo. Ficam à parte porque são chamados no
 * meio do render de listas grandes — e porque comparar ids como STRING é o
 * bug clássico deste tipo de id: "9…" > "10…" em ordem lexicográfica, e a
 * mensagem nova aparece antes da antiga.
 */

import type { Snowflake } from "@greenvoice/shared";
import { EPOCH, timestampOf } from "@greenvoice/shared";

/** a > b, com os ids tratados como números (que é o que são). */
export function idGreater(a: Snowflake | null | undefined, b: Snowflake | null | undefined): boolean {
  if (!a) return false;
  if (!b) return true;
  if (a.length !== b.length) return a.length > b.length;
  return a > b;
}

export function idCompare(a: Snowflake, b: Snowflake): number {
  if (a === b) return 0;
  return idGreater(a, b) ? 1 : -1;
}

export function dateOf(id: Snowflake): Date {
  return timestampOf(id);
}

/** Só para ordenar/agrupar sem construir um Date por mensagem. */
export function msOf(id: Snowflake): number {
  return Number((BigInt(id) >> 22n) + EPOCH);
}

const TIME = new Intl.DateTimeFormat("pt-PT", { hour: "2-digit", minute: "2-digit" });
const DAY = new Intl.DateTimeFormat("pt-PT", { day: "2-digit", month: "long", year: "numeric" });
const SHORT = new Intl.DateTimeFormat("pt-PT", {
  day: "2-digit",
  month: "2-digit",
  year: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
});

export function formatTime(value: string | Date): string {
  return TIME.format(new Date(value));
}

export function formatDay(value: string | Date): string {
  const date = new Date(value);
  const today = new Date();
  const sameDay = (a: Date, b: Date) => a.toDateString() === b.toDateString();
  if (sameDay(date, today)) return "Hoje";
  const yesterday = new Date(today.getTime() - 86_400_000);
  if (sameDay(date, yesterday)) return "Ontem";
  return DAY.format(date);
}

export function formatFull(value: string | Date): string {
  return SHORT.format(new Date(value));
}

export function dayKey(value: string | Date): string {
  const date = new Date(value);
  return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
}
